import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getEnjoyBoardToken} from "../auth/actions/authAction";
import styled from "styled-components";

const EnjoyBoard = () => {
    const dispatch = useDispatch()
    const {enjoyBoardToken} = useSelector(state => state.auth)

    useEffect(() => {
        dispatch(getEnjoyBoardToken())
    }, [dispatch])


    return (
        <Frame
            title={"enjoyBoard"}
            id="inlineFrameExample"
            src={`https://enjoyboard.enjoyyourbusiness.fr/enjoyboard/${process.env.REACT_APP_FQDN}?jwt=${enjoyBoardToken}`}/>

    )
}

const Frame = styled.iframe`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100vh;
`
export default EnjoyBoard